//@flow
import React, {useEffect, useState} from 'react';
import {
  makeStyles,
  Typography,
  MenuItem,
  Grid,
  IconButton,
} from '@material-ui/core';
import CustomSelect from '../../../../../../elements/CustomSelect/CustomSelect';
import {colors} from '../../../../../../assets/styles/colors';
import {Delete} from '@material-ui/icons';
import {useCategories} from '../../../../../categories/utils';

import type {FilterRowProps} from '.';
import CustomChip from '../../../../../../elements/CustomChip';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '.5rem',
    borderRadius: '1rem',
    background: colors.grey200,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '.25rem',
  },
}));

const options = [
  {
    value: true,
    label: 'Incluidos',
  },
  {
    value: false,
    label: 'No incluidos',
  },
];

export default function OrderItemCategoryFilter(props: FilterRowProps) {
  const {conditions = {}, onChange, onDelete} = props;

  const classes = useStyles();
  const categories = useCategories();

  const {included, categories: defaultCategories} = conditions;

  const [selectedCategories, setSelectedCategories] = useState<any>([]);
  const [include, setInclude] = useState(included ?? true);

  const [selectOpen, setSelectOpen] = useState(false);

  const handleSelectClose = () => {
    setSelectOpen(false);
  };

  const handleSelectOpen = () => {
    setSelectOpen(true);
  };

  useEffect(() => {
    if (!defaultCategories || !categories) return;

    const defaultCategoriesMapped = defaultCategories
      .map(cat => {
        const category = categories.find(c => c.name === cat);
        return category;
      })
      .filter(Boolean);

    setSelectedCategories(defaultCategoriesMapped);
  }, [categories, defaultCategories]);

  const handleChange = (include, selectedCategories) => {
    if (!onChange) return;
    const newConditions = {
      ...conditions,
      included: include,
      categories: selectedCategories.map(cat => cat.name),
    };

    onChange(newConditions);
  };

  return (
    <Grid container className={classes.root} spacing={1} alignItems="center">
      <Grid item xs={1}>
        <Typography>productos</Typography>
      </Grid>
      <Grid item xs={2}>
        <CustomSelect
          fullWidth
          className={classes.select}
          value={include}
          onChange={e => {
            setInclude(e.target.value);
            handleChange(e.target.value, selectedCategories);
          }}
        >
          {options.map(el => (
            <MenuItem
              key={'text-color-' + el.label}
              value={el.value}
              className={classes.itemSelectFontColor}
            >
              <Typography>{el.label}</Typography>
            </MenuItem>
          ))}
        </CustomSelect>
      </Grid>
      <Grid item xs={3}>
        <Typography>de la categoría</Typography>
      </Grid>
      <Grid item xs={5}>
        <CustomSelect
          fullWidth
          multiple
          open={selectOpen}
          onOpen={handleSelectOpen}
          onClose={handleSelectClose}
          multiline
          className={classes.select}
          value={selectedCategories}
          onChange={e => {
            setSelectedCategories(e.target.value);
            handleChange(include, e.target.value);
            handleSelectClose();
          }}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(value => (
                <CustomChip color="primary" key={value.id} label={value.name} />
              ))}
            </div>
          )}
        >
          {categories.map(el => (
            <MenuItem
              key={'text-color-' + el.id}
              value={el}
              className={classes.itemSelectFontColor}
            >
              <Typography>{el.name}</Typography>
            </MenuItem>
          ))}
        </CustomSelect>
      </Grid>

      <Grid item xs={1}>
        <IconButton onClick={onDelete}>
          <Delete />
        </IconButton>
      </Grid>
    </Grid>
  );
}
